module Main exposing (main)

import Browser
import Browser.Dom exposing (Viewport)
import Browser.Events
import Browser.Navigation as Navigation exposing (..)
import Element exposing (..)
import Messages exposing (Msg(..))
import Models exposing (ContentType(..), Language(..), Model, routeParser)
import Ports exposing (..)
import Task
import Time
import Update exposing (update)
import Url exposing (Url)
import Url.Parser exposing ((</>))
import View exposing (view)


main : Program () Model Msg
main =
    Browser.application
        { init = init
        , view = view
        , update = update
        , subscriptions = subscriptions
        , onUrlChange = UrlChanged
        , onUrlRequest = LinkClicked
        }


emptyViewport : Viewport
emptyViewport =
    { scene = { width = 0, height = 0 }
    , viewport = { x = 0, y = 0, width = 0, height = 0 }
    }


emptyDevice : Device
emptyDevice =
    { class = Phone, orientation = Portrait }


init : () -> Url -> Navigation.Key -> ( Model, Cmd Msg )
init _ url navigationKey =
    ( { viewport = emptyViewport
      , showModalScreenshot = False
      , mouseHoveringOnLogo = False
      , mouseHoveringOnAppStoreButton = False
      , screenshotFilename = ""
      , contentType = Url.Parser.parse routeParser url
      , userScrolledDown = False
      , device = emptyDevice
      , navigationKey = navigationKey
      , language = English
      , year = 0
      }
    , Cmd.batch
        [ Task.perform UpdateViewport Browser.Dom.getViewport
        , Task.map2 Time.toYear Time.here Time.now |> Task.perform GotYear
        ]
    )


subscriptions : Model -> Sub Msg
subscriptions _ =
    Sub.batch
        [ messageReceiver UpdateViewport
        , Browser.Events.onResize WindowResize
        ]
